import { ref } from 'lib/firebase';

const saveImageInFirebase = (name, image) => {
  const randomId = Math.round(Math.random() * 1_000_000).toString();
  return Promise.all([ref(name).set(image), ref(`${name}Id`).set(randomId)]);
};

export default saveImageInFirebase;
